// src/resources/Letters/MDLetterActions.js
import React from "react";
import { useNavigate } from "react-router-dom";

const MDLetterActions = ({
  status,
  letter,
  signing,
  done,
  onSign,
  isMD,
}) => {
  const navigate = useNavigate(); // ✅ Move inside the component

  // status is already lowercased by parent

  // ✅ Signed
  if (status === "signed") {
    return (
      <div style={{ textAlign: "center", marginTop: 30 }}>
        <p style={{ color: "#27ae60", fontWeight: 600, marginBottom: 12 }}>
          ✅ This letter has been signed and finalized.
        </p>

        {letter?.signedPdfUrl ? (
          <a
            href={letter.signedPdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: "#2e7d32",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: 8,
              textDecoration: "none",
              fontWeight: 600,
              display: "inline-block",
              minWidth: 180,
              textAlign: "center",
            }}
          >
            📥 Download Signed PDF
          </a>
        ) : (
          <p style={{ color: "#999", fontStyle: "italic" }}>
            (Signed, but PDF not found)
          </p>
        )}
      </div>
    );
  }

  // ✅ Pending
  if (status === "pending") {
    // 🧑 Admin view
    if (!isMD) {
      return (
        <div style={{ textAlign: "center", marginTop: 30 }}>
          <p style={{ color: "#999", fontStyle: "italic", marginBottom: 16 }}>
            🕓 Awaiting MD signature.
          </p>

          <button
            onClick={() => navigate("/pendingLetters")}
            style={{
              background: "#999",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "12px 24px",
              fontSize: 16,
              fontWeight: 500,
              cursor: "pointer",
              minWidth: 160,
            }}
          >
            Back
          </button>
        </div>
      );
    }

    // 👔 MD view (sign allowed)
    return (
      <div style={{ textAlign: "center", marginTop: 30 }}>
        {!done ? (
          <>
            <button
              disabled={signing}
              onClick={onSign}
              style={{
                background: signing ? "#aaa" : "#1976d2",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "12px 24px",
                fontSize: 16,
                fontWeight: 600,
                cursor: "pointer",
                minWidth: 180,
                marginRight: 10,
              }}
            >
              {signing ? "Generating & Uploading..." : "✅ Sign & Finalize"}
            </button>

            <button
              onClick={() => navigate("/pendingLetters")}
              style={{
                background: "#999",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "12px 24px",
                fontSize: 16,
                fontWeight: 500,
                cursor: "pointer",
                minWidth: 140,
              }}
            >
              Cancel
            </button>
          </>
        ) : (
          <div
            style={{
              color: "#27ae60",
              fontWeight: 700,
              fontSize: 18,
              marginTop: 10,
            }}
          >
            ✅ Letter Signed & Uploaded Successfully!
          </div>
        )}
      </div>
    );
  }

  // ✅ Any other status (draft, review, etc.)
  if (!isMD) {
    return (
      <div style={{ textAlign: "center", marginTop: 30 }}>
        <button
          onClick={() => navigate("/pendingLetters")}
          style={{
            background: "#999",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "12px 24px",
            fontSize: 16,
            fontWeight: 500,
            cursor: "pointer",
            minWidth: 160,
          }}
        >
          Back
        </button>
      </div>
    );
  }

  // ✅ Default MD view
  return (
    <div style={{ textAlign: "center", marginTop: 30 }}>
      {!done ? (
        <>
          <button
            disabled={signing}
            onClick={onSign}
            style={{
              background: signing ? "#aaa" : "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "12px 24px",
              fontSize: 16,
              fontWeight: 600,
              cursor: "pointer",
              minWidth: 180,
              marginRight: 10,
            }}
          >
            {signing ? "Generating & Uploading..." : "✅ Sign & Finalize"}
          </button>

          <button
            onClick={() => navigate("/pendingLetters")}
            style={{
              background: "#999",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "12px 24px",
              fontSize: 16,
              fontWeight: 500,
              cursor: "pointer",
              minWidth: 140,
            }}
          >
            Cancel
          </button>
        </>
      ) : (
        <div
          style={{
            color: "#27ae60",
            fontWeight: 700,
            fontSize: 18,
            marginTop: 10,
          }}
        >
          ✅ Letter Signed & Uploaded Successfully!
        </div>
      )}
    </div>
  );
};

export default MDLetterActions;
